import { MarketingNav } from '../components/MarketingNav.js';

export interface NavProps {
  locale: 'fr' | 'en';
  onLocaleChange: (next: 'fr' | 'en') => void;
}

/**
 * Homepage compatibility wrapper. The canonical navigation implementation now
 * lives in components/MarketingNav so dedicated pages and the homepage share
 * one interaction and visual system.
 */
export function Nav(props: NavProps) {
  return <MarketingNav {...props} context="home" />;
}
